// extracted by mini-css-extract-plugin
export var content = "_6i-1";
export var modal = "_6i-0";